import { render, staticRenderFns } from "./become-partner-form.vue?vue&type=template&id=486c345d&scoped=true&"
import script from "./become-partner-form.vue?vue&type=script&lang=js&"
export * from "./become-partner-form.vue?vue&type=script&lang=js&"
import style0 from "./become-partner-form.vue?vue&type=style&index=0&lang=css&"
import style1 from "./become-partner-form.vue?vue&type=style&index=1&id=486c345d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486c345d",
  null
  
)

export default component.exports